import axios from "axios";

const axiosApiInstance = axios.create({
  baseURL: process.env.REACT_APP_APIGATEWAY_URL,
  validateStatus: function (status) {
    return status < 400;
  }
});

export default axiosApiInstance;
